export const TabsKey = {
  USAGE_REPORT: 'usageReport'
}
